import { render, staticRenderFns } from "./trendssq.vue?vue&type=template&id=f224a298"
import script from "./trendssq.vue?vue&type=script&lang=js"
export * from "./trendssq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports